/* eslint-disable @nx/enforce-module-boundaries */
import { Button, Card, HStack, Spinner, Stack, Text } from '@mybridge/ui';
import { useRouter } from 'next/router';
import { forwardRef, useContext, useEffect,useState } from 'react';
import { AppliedJobCard } from 'v4/components/jobs/applied-job-card';
import { JobsNotFoundIllustration } from '../404';
import { JobsListingContext } from '../context';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const PendingJobsListing = forwardRef(({ ...props }, ref) => {
  const {
    appliedJobsListing,
    refetchAppliedJobsListing,
    appliedJobsListingHasNextPage,
    fetchAppliedJobsListingNextPage,
    appliedJobsListingIsFetching,
    appliedJobsListingIsLoading,
    removeSavedJob,
    removeSavedJobIsLoading,
    isSavedJob,
    saveJob,
    saveJobIsLoading,
  } = useContext(JobsListingContext);
  const { push } = useRouter();
  const { t } = useTranslator();

  useEffect(() => {
    refetchAppliedJobsListing?.();
  }, []);
  const [selected, setSelected] = useState();

  if (appliedJobsListingIsLoading)
    return (
      <HStack justifyContent="center" py={12}>
        <Spinner />
      </HStack>
    );

  const listing =
    appliedJobsListing?.filter?.((aj) => aj.status === 'APPLIED') ?? [];
  return (
    <Stack>
      {listing?.length > 0 ? (
        <Stack>
          <HStack alignItems="stretch" spacing={0} flexWrap="wrap" gap={5} marginBottom="100px">
            {listing?.map((job, jobIndex) => (
              <Card
              key={jobIndex}
              h={!isMobile?"290px":"auto"}
                w={['100%', '100%', '48.2%']}
                jobIndex={jobIndex}
                p={4}
                border="1px solid #D9D9D9"
                  borderRadius="20px"
                  //boxShadow="none"
                  boxShadow="md"
              >
                <AppliedJobCard
                  href={'/jobs/' + job?.job_details?.id}
                  isSaved={
                    selected?.id === job?.id
                      ? !isSavedJob(job?.id)
                      : isSavedJob(job?.id)
                  }
                  onSaveClick={async () => {
                    const isCurrentlySaved = isSavedJob(job?.id);

                    setSelected(job);

                    if (isCurrentlySaved) {
                      await removeSavedJob({ id: job?.id });
                    } else {
                      await saveJob({ job_id: job?.id });
                    }

                    setSelected(null);
                  }}
                  saveLoading={
                    selected?.id === job?.id &&
                    (saveJobIsLoading || removeSavedJobIsLoading)
                  }
                  onViewDetailsClick={(e) => {
                    push('/jobs/' + job?.job_details?.id);
                  }}
                  job={job}
                />
              </Card>
            ))}
          </HStack>
          {/* {appliedJobsListingHasNextPage ? (
            <Button
              isLoading={appliedJobsListingIsFetching}
              onClick={fetchAppliedJobsListingNextPage}
              variant="secondary"
              ml={isMobile? "6%" : ""}
            >
              Load More
            </Button>
          ) : (
            ''
          )} */}
        </Stack>
      ) : (
        <Stack alignItems="center" justifyContent="center" py="12">
          <JobsNotFoundIllustration />
          <Text>
            {t('jobs.searchForJob') || "Search for a job now and we will work on finding you more suggested jobs!"}
          </Text>
        </Stack>
      )}
    </Stack>
  );
});
